import axios from "axios";
import {API_DOMAIN} from "../constants";

export async function getOrders(page, size) {
    return axios({
        url: API_DOMAIN + "/api/v2/orders",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            consumerUserId: "1033",
            page: page,
            size: size,
        },
    });
}
export async function getOrdersAdminPortal({page, size, fittingId}) {
    const response = await axios({
        url: API_DOMAIN + "/api/v2/orders/adminPortal",
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        params: {
            fittingId,
            includeTracking: true,
            page: page,
            size: size,
        },
    });

    return response.data;
}
